/**
 * Names of routes other code points at by name rather than by path — e.g. the routes the frontend
 * sends to the backend for notifications to open. Renaming one breaks notifications already stored
 * with it, so treat these as stable.
 */
export const RouteName = {
  WebsiteRequest: 'website-request',
  AddMerchant: 'add-merchant',
} as const
export type RouteNameValue = (typeof RouteName)[keyof typeof RouteName]

/** Where billing lives: a tab of the organization settings page. */
export const BILLING_LOCATION = '/organization/settings?tab=billing'
